const filters = {
  subtleGray:
    'invert(77%) sepia(0%) saturate(0%) hue-rotate(348deg) brightness(122%) contrast(86%)',
};

export default filters;
